import React from 'react'
import { Button, Card, Form, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap'
import InputGroupText from 'react-bootstrap/esm/InputGroupText'
import shuffle from '../js/shuffle'

export default class Shoutout extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
    this.state = { messages: [], enabled: false }

    this.messageWindow = React.createRef()
    this.messageField = React.createRef()
    this.nameField = React.createRef()

    this.saveName = this.saveName.bind(this)
    this.sendMessage = this.sendMessage.bind(this)
    this.fetchCookies = this.fetchCookies.bind(this)
    this.newMessage = this.newMessage.bind(this)
    this.scrollDown = this.scrollDown.bind(this)
    this.setNewName = this.setNewName.bind(this)
    this.deleteMessage = this.deleteMessage.bind(this)
    this.previousMessages = this.previousMessages.bind(this)
  }

  render () {
    if (!this.state.enabled) return
    return (
      <Card className='mb-3'>
        <Card.Body className='text-start'>
          <Card.Title className='text-end'>
            { this.state.name
              ? <OverlayTrigger placement='bottom' overlay={<Tooltip>Change Name</Tooltip>}>
                  <Button variant='secondary' size='sm' className='float-start' onClick={this.setNewName}><i className='fa-solid fa-pencil'></i> {this.state.name}</Button>
                </OverlayTrigger>
              : ''
            }
            Shoutout
          </Card.Title>
          <hr />
          <div id="shoutout">
            {this.renderNameField()}
            {this.renderChatForm()}
          </div>
        </Card.Body>
      </Card>
    )
  }

  renderNameField () {
    if (this.state?.name) return
    return (
      <>
        <Card.Text>Start interacting with the presenters and other memebers of the community by entering your name below.</Card.Text>
        <Form.Group>
          <InputGroup>
            <Form.Control type='text' ref={this.nameField} placeholder='Enter name to get started' defaultValue={this.state?.oldName} onKeyUp={this.saveName} required />
            <InputGroupText>
              <Button variant='outline-primary' size='sm' onClick={this.saveName}>Save</Button>
            </InputGroupText>
          </InputGroup>
        </Form.Group>
      </>
    )
  }

  renderChatForm () {
    if (!this.state?.name) return
    return (
      <>
        {this.renderMessages()}
        {this.state?.error ? <div className='mb-2' style={{ color: 'red', fontWeight: 'bold' }}>{this.state.error}</div> : ''}
        <Form.Group>
          <InputGroup>
            <Form.Control ref={this.messageField} placeholder='Start a new message' onChange={e => { this.setState({ message: e.target.value }) }} onKeyUp={this.sendMessage} required />
            <InputGroupText>
              <Button variant='outline-primary' onClick={this.sendMessage}>Send</Button>
            </InputGroupText>
          </InputGroup>
        </Form.Group>
      </>
    )
  }

  renderMessages () {
    return (
      <>
        <div className="mb-2 p-2" ref={this.messageWindow} style={{ height: '300px', overflowY: 'auto', background: '#EEEEEE' }}>
          {this.state.messages.map(message => {
            return (
              <div key={message.id}>
                <strong>{message.name}: </strong> {message.message}
              </div>
            )
          })}
        </div>
      </>
    )
  }

  setNewName () {
    const dt = new Date()
    dt.setDate(dt.getDate() + 28)
    document.cookie = 'shoutoutName=; path=/'
    this.setState({ name: null, oldName: this.state.name })
    this.fetchCookies()
  }

  saveName (e) {
    if (e.key && e.key !== 'Enter') return
    const name = this.nameField.current.value
    const dt = new Date()
    dt.setDate(dt.getDate() + 28)
    document.cookie = `shoutoutName=${name}; expires=${dt.toUTCString()}; path=/`
    this.setState({ name })
    this.fetchCookies()
  }

  sendMessage (e) {
    this.setState({ error: null })
    if (e.key && e.key !== 'Enter') return
    if (!this.state.message) return
    this.socket.emit('message', this.state.message, err => {
      if (err) this.setState({ error: err })
    })
    this.messageField.current.value = ''
    this.setState({ message: null })
  }

  fetchCookies () {
    const cookies = {}
    const rawCookies = document.cookie.split('; ')
    rawCookies.forEach(cookie => {
      cookie = cookie.split('=')
      cookies[cookie[0]] = cookie[1]
    })
    if (cookies.shoutoutName) {
      this.setState({ name: cookies.shoutoutName })
      this.socket.emit('name', cookies.shoutoutName)
    }
  }

  newMessage (obj) {
    this.setState({ messages: [...this.state.messages, obj] })
    setTimeout(this.scrollDown, 10)
  }

  deleteMessage (id) {
    const messages = this.state.messages.filter(message => message.id !== id)
    this.setState({ messages })
  }

  previousMessages (messages) {
    this.setState({ messages })
    setTimeout(this.scrollDown, 10)
  }

  scrollDown () {
    if (!this.messageWindow.current) return
    this.messageWindow.current.scrollTop = this.messageWindow.current.scrollHeight
  }

  componentDidMount () {
    this.socket = window.io('/shoutout', { transports: ['websocket'] })
    this.socket.on('connect', () => {
      this.socket.on('message', this.newMessage)
      this.socket.on('delete', this.deleteMessage)
      this.socket.on('previousMessages', this.previousMessages)
      this.socket.on('enabled', enabled => this.setState({ enabled }))
      this.fetchCookies()
    })
  }

  componentDidUpdate () {
    if (this.state.name) setTimeout(this.scrollDown, 10)
    shuffle.update()
  }
}
